import React from "react";
import { CopyIcon, CloseIcon, LinkIcon, FileUploadIcon, ShareLink } from "asset/icons";
import Swal from "sweetalert2";
import getInitialsMessage from "utilities/messages/getInitialsMessage";

const PaymentLinkSuccessModal = ({ isOpen, onClose, businessName, paymentLink }) => {
    if (!isOpen) return null;

    const handleCopy = () => {
        navigator.clipboard.writeText(paymentLink);
        Swal.fire({
            text: "Payment link copied!",
            icon: "success",
            width: "280px",
            timer: 1200,
            showConfirmButton: false,
        });
    };

    return (
        <div className="fixed inset-0 bg-black/40 z-[100] flex justify-center items-center px-4">
            <div className="bg-white w-full max-w-lg rounded-2xl relative text-center">
                <div className="p-6 ">
                    <button className="absolute right-5 top-5 text-gray-600" onClick={onClose}>
                        <CloseIcon />
                    </button>

                    <div className="flex items-center justify-center">
                        <ShareLink />
                    </div>

                    <h2 className="text-2xl font-semibold text-[#111827] mb-4">
                        Payment link generated
                    </h2>
                    <p className="text-sm text-[#6B7280] mb-8">
                        Share the payment link below to receive funds in your wallet
                    </p>

                    <div className="text-left rounded-xl mt-6">
                        <p className="text-sm text-[#6B7280] mb-1">Click to copy:</p>
                        <div className="border-[#E5E7EB] border p-4">
                            <div className="flex  items-center justify-between">
                                <div className="flex items-center gap-2">
                                    <div className="w-8 h-8 flex items-center justify-center bg-[#E0E7FF] text-[#4338CA] rounded-full text-sm font-semibold uppercase">
                                        {getInitialsMessage(businessName)}
                                    </div>
                                    <span className="font-medium text-sm text-[#111827]">
                                        {businessName}
                                    </span>
                                </div>
                            </div>
                            <div
                                className="mt-3 flex items-center justify-between bg-[#F9FAFB] px-4 py-2 rounded-md cursor-pointer"
                                onClick={handleCopy}
                            >
                                <span className="text-sm text-[#111827]">{paymentLink}</span>
                                <CopyIcon className="w-4 h-4 text-[#6B7280]" />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mt-6 flex justify-end gap-7 border-t p-4">
                    <button onClick={onClose} className="text-sm text-gray-600">
                        Back
                    </button>
                    <button
                        onClick={onClose}
                        className="bg-[#6F00FF] text-white px-6 py-2 rounded-lg text-sm"
                    >
                        Done
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PaymentLinkSuccessModal;
